<template>

  <svg
    t="1632727309196"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4983"
    width="64"
    height="64"
  ><path d="M907.5078125 749.3046875c0 87.36767578-70.83544922 158.203125-158.203125 158.203125h-474.609375c-87.36767578 0-158.203125-70.83544922-158.203125-158.203125v-474.609375c0-87.36767578 70.83544922-158.203125 158.203125-158.203125h474.609375c87.36767578 0 158.203125 70.83544922 158.203125 158.203125v474.609375z" p-id="4984" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeRoundSquare',
} as DefineComponent
</script>